import { CloseCircleFilled } from "@ant-design/icons";
import { Space } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { setPdfConversationMessageRetry } from "../../../../../redux/actions/pdfAI";

function MessageBubble({ type, message, error, ...props }) {
  const dispatch = useDispatch();
  const retryMessage = () => {
    dispatch(setPdfConversationMessageRetry(true));
  }

  return (
    <div className="message-bubble">
      <div className={`message-bubble__${type}`}>{message}</div>
      {error && (
        <Space className={`error-bubble__${type} pointer`} onClick={retryMessage}>
          <CloseCircleFilled /> Press to retry or refresh the page.
        </Space>
      )}
    </div>
  );
}

export default MessageBubble;
